import React from 'react'

const CalendarPage = React.lazy(() => import('pages/Calendar/pages/Calendarpage'));

const CalendarRoutes = [
    {
        path: '/calendar',
        exact: true,
        name: 'Công việc trong tháng',
        function: 'RS_RQ_WARRANTY_REPAIR_VIEW',
        component: CalendarPage,
    }
]

export default CalendarRoutes
